/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const NumericConditionOperationType = {
        EQUAL: 'equal',
        NOT_EQUAL: 'not_equal',
        LESS: 'less',
        MORE: 'more',
        LESS_OR_EQUAL: 'less_or_equal',
        MORE_OR_EQUAL: 'more_or_equal'
} as const;
export type NumericConditionOperationType = typeof NumericConditionOperationType[keyof typeof NumericConditionOperationType];

